import React from "react";
import { MainWrapper } from "../General";
import { Text } from "../Text/Text";
import { Flex } from "../Box";
import { partnersData } from "../../config/partners";
import { styled } from "styled-components";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const PartnerWrapper = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-2px);
  }
  @media (max-width: 600px) {
    scale: 0.6;
  }
`;

const Partners: React.FC = () => {
  const { t } = useTranslation();
  return (
    <MainWrapper flexDirection="column" gap="54px">
      <Flex justifyContent="center" width="100%">
        <Text colored uppercase fontWeight={500} fontSize={18}>
          {t("general.partners")}
        </Text>
      </Flex>
      <Grid container spacing={8} display="flex" justifyContent="center">
        {partnersData.map((partner) => {
          const { name, logo, url } = partner;
          return (
            <PartnerWrapper
              key={name}
              item
              xs={6}
              md={4}
              onClick={url ? () => window.open(url, "_blank") : undefined}
            >
              <img src={logo} />
            </PartnerWrapper>
          );
        })}
      </Grid>
    </MainWrapper>
  );
};

export default Partners;
